import Contact from '../../models/Contact';
import { EntityType } from '../../models/InvestmentEntity';
import InvestmentEntityContact, {
  ContactRole,
  RepresentativeType,
} from '../../models/InvestmentEntityContact';

export interface ContactAssociationStepProps {
  entityId: string;
  entityName: string;
  entityType: EntityType;
  onComplete: () => void;
  onSkip?: () => void;
}

export interface AddContactModalState {
  open: boolean;
  contact: Contact | null;
  role: ContactRole;
  representativeType?: RepresentativeType;
  otherRepresentativeType?: string;
}

export interface ContactAssociationState {
  searchQuery: string;
  searchResults: Contact[];
  associatedContacts: InvestmentEntityContact[];
  loading: boolean;
  associating: boolean;
  error: string | null;
  searchLoading: boolean;
  addContactModal: AddContactModalState;
  validationErrors: string[];
}

export const EMPTY_ADD_CONTACT_MODAL: AddContactModalState = {
  open: false,
  contact: null,
  role: 'OWNER' as ContactRole,
};

export function createInitialContactAssociationState(): ContactAssociationState {
  return {
    searchQuery: '',
    searchResults: [],
    associatedContacts: [],
    loading: true,
    associating: false,
    error: null,
    searchLoading: false,
    addContactModal: { ...EMPTY_ADD_CONTACT_MODAL },
    validationErrors: [],
  };
}
